import * as Tools from '../tools.js';

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const elBaseWidth = document.querySelector('.main-header .base-width, .l-header');

document.documentElement.style.setProperty(
    '--side-margin',
    ((elBaseWidth.parentElement.offsetWidth - elBaseWidth.offsetWidth) / 2) + 'px'
);

window.addEventListener('resize', function() {
    let intSideMargin = (elBaseWidth.parentElement.offsetWidth - elBaseWidth.offsetWidth) / 2;
    document.documentElement.style.setProperty('--side-margin', intSideMargin + 'px');
});

/**
 * Update header size custom properties.
 */
const updateHeaderSize = () => {
    let header = document.querySelector('#header');

    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
};

updateHeaderSize();
window.addEventListener('delayedResize', updateHeaderSize);

window.addEventListener('resize', Tools.debounce(() => {
    window.dispatchEvent(new CustomEvent('delayedResize'));
}));
